export default {
    top_menu: [
        {name:'जरूरी',    id:0},
        {name:'Bisnis pertunjukan', id:1},
        {name:'Memasak',  id:2},
        {name:'Politik',   id:3},
        {name:'+18',  id:4},
        {name:'Masyarakat',   id:5},
        {name:'Kesehatan',   id:6},
    ],
    read_other: 'Baca lebih lajut',
    read_more:  'Keterangan lebih lanjut',
    not_found:  'Tidak ada yang ditemukan',
    read_also:  'Baca juga',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Seluruh hak cipta.',
    subscribe: 'Berlangganan',
    thank_order: 'TERIMA KASIH ATAS ORDERNYA',
    specialist_contact: 'Spesialis kami akan segera menghubungi Anda, tunggu panggilan kami.',
    attention: 'Diskon dari mitra:',
    hurry: 'Cepat, waktu aktivasi diskon terbatas! Anda memiliki segalanya <span id="time" class="time">30:00</span> menit untuk memilih salah satu produk unik ini:',
    hour_ago1: "Sejam yang lalu",
    hour_ago2: "beberapa jam yang lalu",
    hour_ago3: "beberapa jam yang lalu",
    new_publications: "Publikasi baru",
    read: "Membaca",
    today_at: "Hari ini di",
    author_names: ['Agnes Monica','Rossa','Payung Teduh'],
    main_news: "Berita teratas",
    leave_already: "Meninggalkan sudah? Tunggu, kami telah memperbarui berita untuk Anda",
    already_shared: "sudah dibagikan"
}